// extracted by mini-css-extract-plugin
export default {"preTitle":"vehicleItem_preTitle__EDQxY","lineButtons":"vehicleItem_lineButtons__uXk+R","twoInLine":"vehicleItem_twoInLine__MlZC2"};